import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Divider, IconButton } from 'shared/ui'
import { makeTextFieldAutoFocus, TextField } from 'shared/ui/TextField'
import { useConversationsPageLayoutContext } from 'pages/conversations/context/conversationsPageLayoutContext'
import { type SearchInputStore } from 'pages/conversations/pages/search/ui/SearchInput'
import styles from './styles.module.scss'

type ISearchInputProps = {
  store: SearchInputStore
}

export const SearchInput: FC<ISearchInputProps> = observer(({ store }) => {
  const { pageLayoutStore } = useConversationsPageLayoutContext()
  const { titleIconProps, headerMenuTooltipIconProps, headerMenuIconAction } = pageLayoutStore
  const { search, setSearch, focusTrigger, isClear, onClear, onClose, createRecentSearch } = store

  return (
    <div className={styles.header}>
      <div className={styles.left}>
        <IconButton
          iconProps={{
            fontSize: titleIconProps.fontSize,
            icon: titleIconProps.icon,
          }}
          tooltipProps={headerMenuTooltipIconProps}
          variant={'icon'}
          size={'medium'}
          color={'secondary'}
          onClick={headerMenuIconAction}
          ariaLabel='ContainerHeader_titleIcon'
        />
        <Divider orientation='vertical' style={{ height: '16px', margin: '4px' }} />
        <TextField
          variant={'integrated'}
          value={search}
          onChange={setSearch}
          className={styles.search}
          InputProps={{
            placeholder: 'Search contacts and messages',
          }}
          mainActions={[
            makeTextFieldAutoFocus({
              withFocus: true,
              focusTrigger,
            }),
          ]}
          onBlur={createRecentSearch}
        />
      </div>
      <div className={styles.right}>
        {isClear && (
          <>
            <Button
              text={'Clear'}
              size={'medium'}
              contained={'secondary'}
              typeBtn={'text'}
              intent={'passive'}
              onClick={onClear}
            />
            <Divider orientation='vertical' style={{ height: '16px', margin: '4px' }} />
          </>
        )}
        <IconButton
          ariaLabel={'Close'}
          icon={'close'}
          variant={'contained'}
          color={'secondary'}
          onClick={onClose}
        />
      </div>
    </div>
  )
})
